import { Col, Row } from "reactstrap";
import { Href, TemplateButtonsTitle } from "../../../../Constants/Constants";
import { TemplateButtonsData } from "../../../../Data/Bonus/Elements";
import TemplateTabAndContent from "./TemplateTabAndContent";

const TemplateButtons = () => {
  return (
    <section className="template_btn_group">
      <Row>
        <Col md="6" sm="12">
          <div className="element-card">
            <div className="element-card-header heading">
              <h2>{TemplateButtonsTitle}</h2>
            </div>
            <div className="element-card-body typography">
              {TemplateButtonsData.map((group, index) => (
                <div key={index} className="template-btn-group fonts">
                  {index === 0
                    ? group.map((btn, index) => (
                        <div key={index} className={`dot-btn dot-success grow`}>
                          <a className={`icon-btn ${btn.className} button-effect`} href={Href}>
                            {btn.icon}
                          </a>
                        </div>
                      ))
                    : group.map((btn, index) => (
                        <a key={index} className={`icon-btn ${btn.className} button-effect`} href={Href}>
                          {btn.icon}
                        </a>
                      ))}
                </div>
              ))}
            </div>
          </div>
        </Col>
        <TemplateTabAndContent />
      </Row>
    </section>
  );
};

export default TemplateButtons;
